import { has } from 'lodash';
import { useSelector } from 'react-redux';
import { getConnectionOrVendorType } from 'js/lib/ResourceUtils';

type Response = {
  allowSinkAutoMapping: boolean;
  connectionCategory: string;
  connectionType: string;
  connectionTypeCategory: string;
  displayName: string;
  icon: string;
  iconSm: string;
  industryCategory: string;
  key: string;
  label: string;
  name: string;
  value: string;
  vendorId: number;
};

export function useGetSourceMetaByID(sourceID: number): Response | null {
  const sources = useSelector((s: any) => s.entities.sources);
  const vendors = useSelector((s: any) => s.entities.vendors);
  const metaInfoById = useSelector((s: any) => s.paging.metaInfoById);

  const sourceEntity = sources[sourceID];
  let connectionOrVendorType = getConnectionOrVendorType(
    sourceEntity,
    vendors,
    'source_type',
    'vendor_id',
  );

  return connectionOrVendorType && has(metaInfoById, connectionOrVendorType)
    ? metaInfoById[connectionOrVendorType]
    : null;
}
